export enum EventStatus {
   OFF,
   ON,
}

export interface IVector2 {
   x: number;
   y: number;
}
